import { render, staticRenderFns } from "./TiptapInput.vue?vue&type=template&id=51153c6e&scoped=true"
import script from "./TiptapInput.vue?vue&type=script&lang=js"
export * from "./TiptapInput.vue?vue&type=script&lang=js"
import style0 from "./TiptapInput.vue?vue&type=style&index=0&id=51153c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51153c6e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIEditorTextEditor: require('/opt/atlassian/pipelines/agent/build/components/UI/Editor/TextEditor.vue').default})
